export const dimensions: (string | string[])[] = [
  'Sales Segmentation',
  'Influencers',
  ['Channel', 'Preference'],
  ['Communication', 'Style'],
  'Persona',
  'Adoption',
  ['Implementation/', 'Insights'],
];

export const industryAverageData = [80, 67, 60, 65, 60, 70, 60];

// You could also define best practice data here if needed
// export const bestPracticeData = [100, 100, 100, 100, 100, 100, 100];
